import { authenticationInfoSchema } from '../schemas';
import { AUTHENTICATION_INFO_STORAGE_KEY } from '../constants';
import { AuthenticationInfo } from '@/model/auth';

export const getAuthenticationInfoFromStorage = (): AuthenticationInfo | null => {
  const authFromStorage = localStorage.getItem(AUTHENTICATION_INFO_STORAGE_KEY);

  try {
    const authenticationInfo = authenticationInfoSchema.parse(JSON.parse(authFromStorage ?? ''));
    return authenticationInfo;
  } catch (error) {
    return null;
  }
};

export const updateAuthenticationInfoStorageReference = (authenticationInfo: AuthenticationInfo | null) => {
  if (!authenticationInfo) {
    localStorage.removeItem(AUTHENTICATION_INFO_STORAGE_KEY);
    return;
  }

  localStorage.setItem(AUTHENTICATION_INFO_STORAGE_KEY, JSON.stringify(authenticationInfo));
};
